import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

const StandaloneLegalPage = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState('');

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      
      // Get document type from URL
      const urlParams = new URLSearchParams(window.location.search);
      const documentType = urlParams.get('type') || 'terms';
      
      let fileName;
      let pageTitle;
      
      switch (documentType) {
        case 'terms':
          fileName = 'terms.md';
          pageTitle = 'Terms of Service';
          break;
        case 'privacy':
          fileName = 'privacy.md';
          pageTitle = 'Privacy Policy';
          break;
        case 'user-agreement':
          fileName = 'user-agreement.md';
          pageTitle = 'User Agreement';
          break;
        default:
          fileName = 'terms.md';
          pageTitle = 'Terms of Service';
      }
      
      try {
        const response = await fetch(`/markdown/${fileName}`);
        const text = await response.text();
        setContent(text);
        setTitle(pageTitle);
        document.title = `${pageTitle} - MenuAnalyzer.AI`;
      } catch (error) {
        console.error('Error loading markdown file:', error);
        setContent('# Error\n\nUnable to load the requested document.');
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="bg-white shadow-md rounded-lg p-6 md:p-8">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">{title}</h1>
        <div className="prose max-w-none">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
        <div className="mt-8 text-center">
          <button
            onClick={() => window.close()}
            className="px-4 py-2 bg-emerald-600 text-white rounded hover:bg-emerald-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default StandaloneLegalPage;
